// Environment imports
import { environment } from '../../../environments/environment';
// CC-Common imports
import { CCLocalStorageCategory, CCLocalStorageService } from 'cc-common';
// Constant imports
import { StorageKeyConstants } from '../../_constants/storage-key-constants';
import { StringFormatConstants } from '../../_constants/string-format-constants';
import * as i0 from "@angular/core";
import * as i1 from "cc-common";
export class PrecisionService {
    constructor(localStorageService) {
        this.localStorageService = localStorageService;
    }
    getPrecision(customPrecision) {
        if (customPrecision !== null && customPrecision !== undefined) {
            return customPrecision;
        }
        else {
            const precision = this.localStorageService.getItem(StorageKeyConstants.userPrecisionKey, CCLocalStorageCategory.PREF);
            if (!!precision && Number.isInteger(parseInt(precision, 10))) {
                return parseInt(precision, 10);
            }
        }
        return environment.defaultRounding;
    }
    getCurrencyFormat(precision) {
        return this.updatePrecisionPoint(StringFormatConstants.currencyFormat, precision);
    }
    getDecimalFormat(precision) {
        const customPrecision = this.getPrecision(precision);
        return { type: 'decimal', precision: customPrecision };
    }
    getCountFormat() {
        return { type: 'decimal', precision: 0 };
    }
    updatePrecisionPoint(customFormat, precision) {
        const customPrecision = this.getPrecision(precision);
        const precisionFormat = `.${'0'.repeat(customPrecision)}`;
        return customFormat.replace(/.00/gi, precisionFormat);
    }
    getRealNumber(num) {
        const exp = num.toExponential();
        const tokens = exp.split('e').map((n) => Number(n));
        let factor = 0;
        if (tokens[1] < 0) {
            factor = Math.abs(tokens[1]);
            factor += tokens[0].toString().replace('-', '').replace('.', '').length - 1;
        }
        else {
            const token = tokens[0].toString();
            if (token.indexOf('.') !== -1) {
                const decimalPlaces = token.split('.').reverse()[0].length;
                factor = Math.max(0, decimalPlaces - tokens[1]);
            }
        }
        return num.toFixed(factor);
    }
    getRoundedNumber(value, precision) {
        let result = 0;
        if (!!value) {
            const customPrecision = precision || this.getPrecision();
            const realNumber = this.getRealNumber(value);
            const roundedNumber = Math.round(Number(`${realNumber}e${customPrecision}`));
            result = Number(`${roundedNumber}e-${customPrecision}`);
            if (result === -0) {
                result = 0;
            }
        }
        return result;
    }
}
PrecisionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PrecisionService_Factory() { return new PrecisionService(i0.ɵɵinject(i1.CCLocalStorageService)); }, token: PrecisionService, providedIn: "root" });
